const loading = state => state.loading;
const data = state => state.data;
const portalId = state => state.data.portalId;

export default {
  loading,
  data,
  portalId
};
